// import { toast } from "react-toastify";
import toast from "react-hot-toast";

// import "react-toastify/dist/ReactToastify.css";

// const Toast = () => toast('Here is your toast.');

export const SuccessToast = (message: string) => {
  return toast.success(message, {
    duration: 4000,
    position: "top-center",

    // Styling
    style: {},
    className: "",

    // Custom Icon
    // icon: "👏",

    // Change colors of success/error/loading icon
    iconTheme: {
      primary: "#000",
      secondary: "#fff",
    },

    // Aria
    ariaProps: {
      role: "status",
      "aria-live": "polite",
    },

    // Additional Configuration
    removeDelay: 1000,
  });
};

// // Error toast component
export const ErrorToast = (message: string) => {
  return toast.error(message, {
    duration: 4000,
    position: "top-center",

    // Styling
    style: {},
    className: "",

    // Custom Icon
    // icon: "👏",

    // Change colors of success/error/loading icon
    iconTheme: {
      primary: "#000",
      secondary: "#fff",
    },

    // Aria
    ariaProps: {
      role: "status",
      "aria-live": "polite",
    },

    // Additional Configuration
    removeDelay: 1000,
  });
};

export const InfoToast = (message: string) => {
  return toast(message, {
    duration: 4000,
    position: "top-center",

    // Styling
    style: {},
    className: "",

    // Custom Icon
    // icon: '👏',

    // Change colors of success/error/loading icon
    iconTheme: {
      primary: "#000",
      secondary: "#fff",
    },

    // Aria
    ariaProps: {
      role: "status",
      "aria-live": "polite",
    },

    // Additional Configuration
    removeDelay: 1000,
  });
};
